import React from 'react';
import { Button } from 'react-bootstrap';

/* 词库过滤 */
class FilterWordsBar extends React.Component {
  constructor(props) {
    super(props);
    this.handleGradeOnChange = this.handleGradeOnChange.bind(this);
    this.handleUnitChange = this.handleUnitChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.handleWrongWordCheckClick = this.handleWrongWordCheckClick.bind(this);
  }
  handleGradeOnChange(event) {
    this.props.onGradeChange(event);
  }
  handleUnitChange(event){
    this.props.onUnitChange(event);
  }
  handleLogin(event) {
    this.props.onLogin(event);
  }
  handleLogout(event) {
    this.props.onLogout(event);
  }
  handleRegister(event) {
    this.props.onRegister(event);
  }
  handleWrongWordCheckClick(event) {
    this.props.onWrongWordCheckClick(event)
  }
  render(){
    const categories = this.props.categories;
    const units = this.props.units;
    const categoriesOptions = categories.map((category) =>
      <option key={category.id} id={category.id} value={category.id}>{category.name}</option>
    );
    const unitsOptions = units.map((unit) =>
      <option key={unit.id} id={unit.id} value={unit.name}>{unit.name}</option>
    );
    return (
      <form>
        <select name="grade_select" onChange={this.handleGradeOnChange}>
          <option id="-1" value="-1">请选择年级</option>
          {categoriesOptions}
        </select>&nbsp;
        <select name="unit_select" onChange={this.handleUnitChange}>
          <option id="-1" value="-1">请选择单元</option>
          {unitsOptions}
        </select>
        &nbsp;{ this.props.isLogin && (<Button onClick={this.handleWrongWordCheckClick} style={{"float":"right"}} >错词抽查</Button>)}
      </form>
    )
  }
}

export default FilterWordsBar;



// WEBPACK FOOTER //
// ./src/Test_FilterWordBar.js